import React from 'react'
import GlobalStorage from '../storage/GlobalStorage'
import AppConnector from '../../AppConnector'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash,faPlusCircle,faEdit} from '@fortawesome/free-solid-svg-icons'
import {Container,Row,Col} from 'reactstrap';

export default class extends React.Component{

  constructor(props)
  {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false,
      page:1
    };
    this.GS = new GlobalStorage();
    this.connector = new AppConnector();
    
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render()
  { var t= this;
    if (global.DEBUG) console.log(this.GS.getUserStory());
    return (
      <div className="bg-light">
        <Container>
          <Row>
            <Col>
              <h2 className="mt-3">我的故事</h2>
            </Col>
          </Row>
          <Row>
            <Col md="3" className="align-self-center text-center">                 
              <span className="btn m-0 p-0">
                <FontAwesomeIcon icon={faPlusCircle} className="fa-3x" title="新增" onClick={()=>{
                  this.props.toggleModalState("createStory");
                  this.props.toggleModal(true);            
                  this.GS.getStory().uuid='';  
                  this.GS.getStory().suggested=false;
                  this.GS.getStory().type="AMATEUR_STORY";
                }}/>
              </span>
              <h2>創作故事</h2>                          
            </Col>             
            {
              this.GS.getUserStory().map((story,i)=>{
                let bookCover;
                if (story.image.hasOwnProperty('large'))
                  bookCover = <img src={story.image.large} class="img-fluid"/>
                else 
                  bookCover = <img src="story.jpg"  class="img-fluid"/>
                return(
                  <Col md="3">
                    <div class="hovereffect p-3">
                      {bookCover}
                      
                      <h4 className="mt-3">{story.storyName}</h4>
                      <h5>{story.author}</h5>
                      {(global.DEBUG)?story.uuid:''}
                      <div class="overlay">                  
                        <p class="icon-links">
                          <a href="javascript:void(0)">                      
                            <FontAwesomeIcon className={`text-white`} icon={faTrash} title="刪除" uuid={story.uuid} onClick={()=>{
                              var r = window.confirm("確認刪除?");
                              if (r ===true ) this.connector.deleteStory(story.uuid,()=>{t.forceUpdate();},this.state.page);                                                            
                            }}/>
                          </a>                    
                          <a href="javascript:void(0)">                      
                            <FontAwesomeIcon className={`mr-3 text-white`} icon={faEdit} title="編輯" uuid={story.uuid} onClick ={()=>{

                              var editStory = {
                                storyName:story.storyName,
                                author:story.author,
                                description:story.description,
                                image:story.image,
                                category:story.category,
                                uuid:story.uuid,
                                suggested:story.suggested,
                                type:story.type,
                                channel:story.channel,
                                warningList:new Set(story.warningList)
                              }
                                this.GS.setStory(editStory);
                                //console.log("UUID:");
                                //console.log(this.GS.getStory());
                                this.connector.listStoryEpisode(
                                  ()=>{
                                    this.props.switchMenu('Story');
                                    this.props.switchMain('Story');
                                  }
                                );
                                
                                
                              }}/>
                          </a>                    
                        </p>
                      </div>                
                    </div>
                  </Col>
                )
              })
            }
            
            
          </Row>
          <Row>
            <ul class="pagination">
            {Array.apply(0, Array(this.GS.totalPages)).map(function (x, i) {
              return (<li class={(t.state.page==i+1)?`active`:``} onClick={()=>{t.connector.listStory(
                          ()=>{t.forceUpdate();t.setState({page:i+1})},i+1)
                          }}>{i+1}</li>);
            })}
            </ul>            
          </Row>
        </Container>
      </div>
    )
  }
}